module.exports = __webpack_public_path__ + "img/werknemers-icon.9be4bf6.png";